const AppContainer = ({ children, className }) => (
  <div className={`container mx-auto ${className}`}>{children}</div>
);

export default AppContainer;
